/*global Modernizr, trapFocus, console */
/*jslint browser:true */

(function() {
  'use strict';

  var current_rates_container = document.getElementById('current-rates'),
      rate_directions = {
        'nb': {
          'cvz': 'Cesar Chavez',
          'farwest': 'Far West'
        },
        'sb': {
          'parmer': 'Parmer',
          '2222': '2222'
        }
      },
      tpn_map = {
        'cvz': [
          'CVZ to 183',
          'CVZ to Parmer'
        ],
        'farwest': [
          '2222 to Parmer'
        ],
        'parmer': [
          'Parmer to 2222',
          'Parmer to 5th/CVZ'
        ],
        '2222': [
          '2222 to 5th/CVZ'
        ]
      };

  if(current_rates_container) {
    var historical_rate_error = document.getElementById('hisra-current-error');

    fetchRates();
  }

  function updateSign(sign, rates, direction) {
    sign.innerHTML = '';
    sign.classList.remove('no-sign', 'sign-1-nb', 'sign-1-sb', 'sign-2-nb', 'sign-2-sb');

    if(rates === 0) {
      sign.classList.add('no-sign');
      return;
    }

    sign.classList.add('sign-' + rates.length + '-' + direction);

    rates.forEach((rate, index) => {
      sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((rate.rate == 'CLOSED') ? 'red' : 'white') + ';" class="price-box price-box-' + (index + 1) + '">' + rate.rate + '</div>');
      sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((rate.pbm == 'CLOSED') ? 'red' : 'white') + ';" class="price-box-pbm price-box-pbm-' + (index + 1) + '">' + rate.pbm + '</div>');
    })
  }

  function buildRates(data) {
    var sign_information = [];

    for(var key in tpn_map) {
      // skip loop if the property is from prototype
      if (!tpn_map.hasOwnProperty(key)) continue;

      sign_information[key] = [];
    }

    data.map(function(datum) {
      var clean = {};
      clean.startFormat = set_rate_format_date(datum.startTimeStamp);
      clean.tpn = datum.tollingPointName.slice(9, datum.tollingPointName.length);
      clean.status = datum.status || 'O';

      if(clean.status == 'CLOSED') {
        clean.rate = 'CLOSED';
        clean.pbm = 'CLOSED';
      } else {
        clean.rate = set_rate_format_money(datum.tripRate);
        clean.pbm = set_rate_format_money(datum.pbmRate || 0.00);
      }

      for(var key in tpn_map) {
        // skip loop if the property is from prototype
        if (!tpn_map.hasOwnProperty(key)) continue;

        tpn_map[key].forEach((tollingPoint, index) => {
          if(tollingPoint === clean.tpn) {
            sign_information[key].push(clean);
          }
        });
      }

      return clean;
    });

    for(var key in tpn_map) {
      // skip loop if the property is from prototype
      if (!tpn_map.hasOwnProperty(key)) continue;

      var direction;

      for(var direction_key in rate_directions) {
        // skip loop if the property is from prototype
        if (!rate_directions.hasOwnProperty(direction_key)) continue;

        if(rate_directions[direction_key].hasOwnProperty(key)) {
          direction = direction_key;
        }
      }

      updateSign(document.getElementById('hisra_sign_' + key), sign_information[key], direction);
    }
  }

  function fetchRates() {
    historical_rate_error.classList.add('hide');

    var request = new XMLHttpRequest();

    request.addEventListener('readystatechange', function() {
      if(this.readyState === 4) {
        if (this.status === 200) {
          var data = JSON.parse(this.response);

          if(data) {
            buildRates(data);
          } else {
            console.log('JSON Error', this.response);
            historical_rate_error.classList.remove('hide');
          }
        } else {
          console.log('Error', this.statusText);
          historical_rate_error.classList.remove('hide');
        }
      }
    });

    request.open('POST', ajaxurl, true);

    var today = new Date();

    var data = new FormData();
    data.append('action', 'historical_rates');
    data.append('starttime', get_current_date());

    request.send(data);
  }

  function get_current_date() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
    let hh = today.getHours();
    let ii = today.getMinutes();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    if (hh < 10) hh = '0' + hh;
    if (ii < 10) ii = '0' + ii;

    // m/d/Y H:i
    return mm + '/' + dd + '/' + yyyy + ' ' + hh + ':' + ii;
  }

  function set_rate_format_date(dateInfo) {
    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    if (dateInfo) {
        var fractionalSecond = Math.round(dateInfo.fractionalSecond * 1000) / 1000,
            seconds = pad(dateInfo.second, 2) + '' + fractionalSecond;
        return pad(dateInfo.month, 2)+'/'+pad(dateInfo.day, 2)+'/'+pad(dateInfo.year, 4)+' '+
            pad(dateInfo.hour, 2)+':'+pad(dateInfo.minute, 2)+':'+ pad(dateInfo.second, 2);
    } else return '00/00/0000 00:00:00';
  }

  function set_rate_format_money(rate) {
    var moola = rate.toFixed(2);
    return '$ '+moola;
  }
}());